import styled from '@emotion/styled'

export default styled.div`
  text-align: left;
  line-height: 1.7;
  margin-bottom: 1.2rem;
`
